import { sectorService } from '../services';

export const hasRealActivities = async (sectorId) => {
  if (!sectorId) return false;

  try {
    const activities = await sectorService.showActivity(sectorId);
    return activities?.sector?.some((activity) => !activity.default) || false;
  } catch {
    return false;
  }
};

export const navigateToMasterPlan = async (sector, history) => {
  const hasGantt = sector?.gantt || sector?.gantts?.length > 0;

  if (hasGantt) {
    return history.push('/gantt/' + sector.id + '/ganttchart');
  }

  history.push('/masterplan');
};
